module.exports = __webpack_public_path__ + "static/img/LxbwywxtV1.52fc1f78.png";